var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.updateLocation}},[_c('v-icon',{attrs:{"title":_vm.title,"color":"primary","disabled":!_vm.location,"dense":""}},[_vm._v("mdi-crosshairs-gps")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }